module.exports = require("./kam.js");